export const siteConfig = Object.freeze({
  title: 'GoodFoodTalks',
  description: 'GoodFoodTalks',
  twitterCreator: '@GoodFoodTalks',
});
